import { useProxyXLSExport } from '../logic/useProxyXLSExport';
import { withSuspense } from 'venn-utils';

const ProxyXLSExport = () => {
  useProxyXLSExport();
  return null;
};

export default withSuspense(null, ProxyXLSExport);
